import React from 'react';
import { useTheme, spacing } from '@fti/design-system';
import type { ColumnType } from '../../types/columnType';

interface ColumnTypeBadgeProps {
  type: ColumnType;
  onClick?: () => void;
}

const TYPE_COLORS: Record<ColumnType, { bg: string; text: string }> = {
  Text: { bg: '#e8eaf6', text: '#3949ab' },
  Number: { bg: '#e8f5e9', text: '#2e7d32' },
  Date: { bg: '#fff3e0', text: '#e65100' },
  DateTime: { bg: '#fbe9e7', text: '#bf360c' },
  Percentage: { bg: '#f3e5f5', text: '#7b1fa2' },
  Currency: { bg: '#e0f2f1', text: '#00695c' },
  Boolean: { bg: '#fce4ec', text: '#c62828' },
  URL: { bg: '#e1f5fe', text: '#0277bd' },
};

const TYPE_ICONS: Record<ColumnType, string> = {
  Text: 'Aa',
  Number: '#',
  Date: '\u{1F4C5}',
  DateTime: '\u{1F552}',
  Percentage: '%',
  Currency: '$',
  Boolean: '\u{2714}',
  URL: '\u{1F517}',
};

export const ColumnTypeBadge: React.FC<ColumnTypeBadgeProps> = ({ type, onClick }) => {
  const { theme } = useTheme();
  const colors = TYPE_COLORS[type];
  const icon = TYPE_ICONS[type];

  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: spacing.xs,
        padding: `${spacing.xs} ${spacing.sm}`,
        borderRadius: '6px',
        border: 'none',
        backgroundColor: colors.bg,
        color: colors.text,
        fontSize: '0.8rem',
        fontWeight: 600,
        fontFamily: 'inherit',
        cursor: onClick ? 'pointer' : 'default',
        lineHeight: 1.4,
        whiteSpace: 'nowrap',
      }}
      title={`Column type: ${type}. ${onClick ? 'Click to change.' : ''}`}
      aria-label={`Column type: ${type}`}
    >
      <span style={{ fontSize: '0.75rem' }}>{icon}</span>
      {type}
    </button>
  );
};
